import { IconButton } from "@material-ui/core";
import Tooltip from "screens/ContentTab/features/common/Tooltip";
import TypedIcon from "../common/TypedIcon";
const handleClick = (url, title, accessRestricted) => {
    if (accessRestricted) {
        window.DialogManager.GlobalDialog.alert("Access restricted", "Access restricted based on user security rights.");
    }
    else {
        window.RootAPI.Navigation.openUrl(url, title);
    }
};
const DirectNotificationIcon = ({ notification }) => (<Tooltip title={notification.description}>
    <IconButton style={{ color: "white" }} className="NotificationIcon-button" onClick={() => handleClick(notification.url, notification.title, notification.accessRestricted)} data-identification={`directNotification-${notification.description}`}>
      <TypedIcon badge={<b className="NotificationIcon-badge" style={{
            background: notification.background,
            color: notification.color,
        }}>
            {notification.count}
          </b>} className="NotificationIcon" size={notification.iconSet.startsWith("material-icons") ? 19 : 16} type={notification.iconSet}>
        {notification.icon}
      </TypedIcon>
    </IconButton>
  </Tooltip>);
export default DirectNotificationIcon;
